// Сохранение хотсит-партии в localStorage (между действиями; запрос движка не сохраняется).
import type { Game, PlayerId } from '../types.ts';
import type { Screen, SetupUi } from './state.ts';

export const SAVE_KEY = 'krutagidon-save-v2';
const OLD_SAVE_KEY = 'krutagidon-save-v1';

export interface SaveData {
  G: Game;
  /** состояние до последнего действия — чтобы «шаг назад» пережил закрытие приложения (см. undoSnapshot) */
  undoBase?: Game | null;
  viewer: PlayerId | null;
  screen: Screen;
  setup: SetupUi;
  seenSeq: Record<number, number>;
}

function looksLikeSetup(x: unknown): x is SetupUi {
  if (!x || typeof x !== 'object') return false;
  const s = x as Partial<SetupUi>;
  return typeof s.pid === 'number' && (s.familiar === null || s.familiar === undefined || typeof s.familiar === 'string');
}

function looksLikeGame(x: unknown): x is Game {
  if (!x || typeof x !== 'object') return false;
  const g = x as Partial<Game>;
  return Array.isArray(g.players) && typeof g.phase === 'string' && Array.isArray(g.market);
}

export function saveGame(data: SaveData): void {
  try {
    localStorage.setItem(SAVE_KEY, JSON.stringify(data));
  } catch {
    /* переполнение/приватный режим — сохранение необязательно */
  }
}

/** Сохранённая партия (или null, если её нет или она повреждена) */
export function loadGame(): SaveData | null {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(SAVE_KEY) ?? localStorage.getItem(OLD_SAVE_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const s = JSON.parse(raw) as Partial<SaveData>;
    if (!looksLikeGame(s.G)) return null;
    return {
      G: s.G,
      ...(looksLikeGame(s.undoBase) ? { undoBase: s.undoBase } : {}),
      viewer: typeof s.viewer === 'number' ? s.viewer : null,
      screen: s.screen === 'setup' ? 'setup' : 'game',
      setup: looksLikeSetup(s.setup) ? { pid: s.setup.pid, traitId: s.setup.traitId ?? null, familiar: s.setup.familiar ?? null, freeFam: s.setup.freeFam ?? null, stage: 'pass', online: false } : { pid: 0, traitId: null, familiar: null, freeFam: null, stage: 'pass', online: false },
      seenSeq: s.seenSeq && typeof s.seenSeq === 'object' ? s.seenSeq : {},
    };
  } catch {
    return null;
  }
}

export function clearSave(): void {
  try {
    localStorage.removeItem(SAVE_KEY);
    localStorage.removeItem(OLD_SAVE_KEY);
  } catch {
    /* ignore */
  }
}
